/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { generatePresignedUrlModelSchema } from "../generatePresignedUrlModelSchema.ts";
import { presignedUrlModelSchema } from "../presignedUrlModelSchema.ts";
import { z } from "zod";

/**
 * @description Подписанный url
 */
export const postApiFilesPresignedUrl200Schema = z.lazy(() => presignedUrlModelSchema)

/**
 * @description Ошибка валидации | Ошибка во время генерации подписанного URL
 */
export const postApiFilesPresignedUrl400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiFilesPresignedUrl401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiFilesPresignedUrl403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiFilesPresignedUrl500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const postApiFilesPresignedUrlMutationRequestSchema = z.lazy(() => generatePresignedUrlModelSchema).describe("Тело запроса")

export const postApiFilesPresignedUrlMutationResponseSchema = z.lazy(() => postApiFilesPresignedUrl200Schema)